module.exports = __webpack_public_path__ + "img/CCC-PYHL-14A-7.5.1eabe41a.jpg";